import * as React from 'react'
import { IconWithText } from '@components/icon-with-text'
import { SubscriptionWithBenefitCodeInput } from '@modules/aside/subscription-with-benefits/subscription-with-benefit-code-input'

export const LocalForClientWithBenefitAvailable = (): JSX.Element => (
  <div>
    <p className="mt-4">
      Ten lokal dostępny jest tylko w ramach <strong>rezerwacji standardowej</strong> lub po wpisaniu kodów:
    </p>
    <ul className="list-unstyled">
      <ListItem title="Wakacyjny Pakiet Korzyści" />
      <ListItem title="Wakacje w Nieskończoność" />
      <ListItem title="Pakietów z wykupioną opcją dodatkową" />
    </ul>
    <SubscriptionWithBenefitCodeInput
      label={
        <label htmlFor="code" className="font-size-md fw-normal d-block">
          Jeśli posiadasz jeden z tych kodów wpisz go poniżej:
        </label>
      }
    />

    <hr className="mt-4" />
    <p>
      Chcesz zyskać dostęp do <strong className="text-purple">puli lokali specjalnych?</strong>
    </p>
    <section className="rounded p-3 subscription-with-benefits-owner-modal__contact-banner">
      <p className="font-size-sm text-darker-gray mb-2 fw-bold">Zadzwoń i zapytaj o szczegóły:</p>
      <div className="d-flex">
        <IconWithText text="696 11 67 67" iconClassName="uil-mobile-android me-2" wrapperClassName="text-purple" />
        <span className="px-2 text-purple">lub</span>
        <IconWithText text="735 200 800" iconClassName="uil-mobile-android me-2" wrapperClassName="text-purple" />
      </div>
    </section>
  </div>
)

const ListItem = ({ title }) => (
  <li>
    <IconWithText text={title} wrapperClassName="text-purple" iconClassName="uil-check font-size-xl me-2 lh-0" />
  </li>
)
